'use client';

interface ThumbtackLoaderProps {
  title?: string;
  subtitle?: string;
}

export default function ThumbtackLoader({
  title = 'Finding the best contractors for your repair',
  subtitle = 'Searching for top-rated professionals in your area',
}: ThumbtackLoaderProps) {
  return (
    <div className='flex flex-col items-center justify-center gap-6 py-16'>
      <div className='relative'>
        <div className='absolute -inset-2 animate-pulse rounded-2xl bg-[#009fd9]/20' />
        <div className='relative flex h-20 w-20 items-center justify-center rounded-xl bg-white p-3 shadow-sm'>
          <img
            src='https://thumbtack-brand.netlify.app/_next/static/media/logo.17900690.svg'
            alt='Thumbtack'
            className='h-full w-full object-contain'
          />
        </div>
      </div>
      <div className='text-center'>
        <h2 className='text-lg font-semibold text-gray-800'>{title}</h2>
        <p className='mt-1 text-sm text-gray-500'>{subtitle}</p>
      </div>
      <div className='flex items-center gap-1.5'>
        <span
          className='h-2 w-2 animate-bounce rounded-full bg-[#009fd9]'
          style={{ animationDelay: '0ms' }}
        />
        <span
          className='h-2 w-2 animate-bounce rounded-full bg-[#009fd9]'
          style={{ animationDelay: '150ms' }}
        />
        <span
          className='h-2 w-2 animate-bounce rounded-full bg-[#009fd9]'
          style={{ animationDelay: '300ms' }}
        />
      </div>
      <div className='flex items-center gap-1.5 text-xs text-gray-400'>
        <span className='font-medium uppercase tracking-wide'>Powered by</span>
        <img
          src='https://thumbtack-brand.netlify.app/_next/static/media/logo.17900690.svg'
          alt='Thumbtack'
          className='h-3 w-auto opacity-60'
        />
      </div>
    </div>
  );
}
